import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { formatCurrency, useModuloFiscalData } from './useModuloFiscalData';
import './moduloFiscal.css';

export default function ModuloFiscalDashboardPage() {
  const { fiscalId } = useParams();
  const navigate = useNavigate();
  const { loading, error, fiscal, contratos, qtdNfs, valorTotal } = useModuloFiscalData(fiscalId);

  if (loading) {
    return (
      <div className="mf-page mf-page--embedded">
        <div className="mf-state">
          <CircularProgress sx={{ color: 'var(--ep-accent)' }} />
          <p>Carregando dashboard…</p>
        </div>
      </div>
    );
  }

  if (error || !fiscal) {
    return (
      <div className="mf-page mf-page--embedded">
        <div className="mf-state">
          <p>{error || 'Fiscal não encontrado.'}</p>
          <button
            type="button"
            className="mf-page__back"
            onClick={() => navigate('/home', { state: { openFiscalMap: true } })}
          >
            Voltar ao mapa
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="mf-page mf-page--embedded">
      <header className="mf-page__header">
        <div>
          <h1 className="mf-page__title">{fiscal.nome}</h1>
          <p className="mf-page__meta">
            Setor: <strong>{fiscal.setor || '—'}</strong>
            {fiscal.email ? ` · ${fiscal.email}` : ''}
          </p>
        </div>
      </header>

      <p className="mf-note">
        Visão de consulta do fiscal. Edição e novos contratos/aditivos continuam no setor de Contratos.
      </p>

      <div className="mf-kpis">
        <div className="mf-kpi mf-kpi--anim" style={{ '--i': 0 }}>
          <span className="mf-kpi__label">Valor total (mensal)</span>
          <span className="mf-kpi__value">{formatCurrency(valorTotal)}</span>
        </div>
        <div className="mf-kpi mf-kpi--anim" style={{ '--i': 1 }}>
          <span className="mf-kpi__label">Contratos ativos</span>
          <span className="mf-kpi__value">{contratos.length}</span>
        </div>
        <div className="mf-kpi mf-kpi--anim" style={{ '--i': 2 }}>
          <span className="mf-kpi__label">Notas fiscais</span>
          <span className="mf-kpi__value">{qtdNfs}</span>
        </div>
      </div>
    </div>
  );
}
